import { useDispatch, useSelector } from 'react-redux'
import { tryRemovePageTab } from '../../../../redux/slices/dynamicUiSlice'
import { CustomTabRef } from '../../../../components/tab/CustomTab'
import CustomIcon from '../../../../components/CustomIcon'
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu'


const DeleteTabMenu = () => {

  const dispatch = useDispatch()

  const isLoading = useSelector((state) => state.dynamicElements.editing.loading)


  const handleDeletePageTab = () => {
    dispatch(tryRemovePageTab())
  }
  return (
    <DropdownMenu placement="bottom-end" shouldFlip isLoading={isLoading} isDisabled={isLoading}
                  trigger={({ triggerRef, isSelected, testId, ...props }) => (
                    <CustomTabRef ref={triggerRef} {...props} active={isSelected}
                                  className="flex items-center p-0.5 bg-red-100 rounded">
                      <CustomIcon icon="close" size="lg" className="cursor-pointer leading-7 text-danger" />
                    </CustomTabRef>)}
    >
      <DropdownItemGroup>
        <DropdownItem onClick={handleDeletePageTab}>
          Delete Tab
        </DropdownItem>
      </DropdownItemGroup>
    </DropdownMenu>

  )
}

export default DeleteTabMenu
